/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
import TileLayer from 'ol/layer/Tile';
import Map from 'ol/Map';
import { fromLonLat, transformExtent } from 'ol/proj';
import { ImageWMS, OSM } from 'ol/source';
import View from 'ol/View';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Swipe from 'ol-ext/control/Swipe';
import 'ol-ext/control/Swipe.css';
import 'ol/ol.css';
import { Card, CardBody, CardHeader, Col, Dropdown, DropdownMenu, DropdownToggle, Input, Row } from 'reactstrap';
import Select from 'react-select';
import { AuthUser, getDateOnly } from 'Components/Common/Util';
import withRouter from 'Components/Common/withRouter';
import * as url from '../../../src/helpers/url_helper';
import { CreateDrawlayers, Createlayers, fetchAndParseCapabilities, fitMapToLayerDetails, fitMapToSourceLayersExtent } from 'Components/Common/MapUtils';
import layerimg from '../../assets/images/commons/Path 24462.svg';
import VectorLayer from 'ol/layer/Vector';
import ImageLayer from 'ol/layer/Image';
import { defaults as defaultControls, FullScreen, ScaleLine } from 'ol/control';
import homeImg from '../../assets/images/commons/home.svg';
import { toast } from 'react-toastify';

const ComparisionTool = (props: any) => {
    const api = props?.router?.apiClient;
    const { mines, selectedMine } = useLocation().state;
    const roles = AuthUser()?.userProfile?.roles;
    const role = roles[0]?.role;
    const mapElement: any = useRef();
    const mapRef: any = useRef();

    const [loading, setLoading] = useState(false);
    const [map, setMap] = useState<any>();
    const [control, setControl] = useState();

    // Left side: the mine selected on the map; Right side: most recently added mine (by createdAt)
    const initialLeft = selectedMine && mines?.some((m: any) => m.value === selectedMine.value) ? selectedMine : mines[0];
    const sortedByRecent = [...(mines || [])].sort((a: any, b: any) => {
        const dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
        const dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
        return dateB - dateA;
    });
    const initialRight = sortedByRecent.length > 0 ? sortedByRecent[0] : mines[1];
    // Avoid same mine on both sides
    const safeRight = initialRight?.value === initialLeft?.value && mines?.length > 1
        ? sortedByRecent.find((m: any) => m.value !== initialLeft?.value) || mines[1]
        : initialRight;

    const [selectedLeftMine, setSelectedLeftMine] = useState(initialLeft);    
    const [selectedRightMine, setSelectedRightMine] = useState(safeRight);

    const [layerState1, setLayerState1] = useState();
    const [layerState2, setLayerState2] = useState();
    const [source1, setSource1] = useState([]);
    const [source2, setSource2] = useState([]);
    const [feature1, setFeature1] = useState<any[]>([]);
    const [feature2, setFeature2] = useState<any[]>([]);

    const [selectAll, setSelectAll] = useState(false);
    const [selectAll2, setSelectAll2] = useState(false);
    const [isLayersDropdown, setIsLayersDropDown] = useState(false);
    const [isLayersDropdown2, setIsLayersDropDown2] = useState(false);
    const [isLayersDropdown3, setIsLayersDropDown3] = useState(false);
    const [isLayersDropdown4, setIsLayersDropDown4] = useState(false);

    // Track previous right mine selection to detect right-side changes
    const prevRightMineRef = useRef<any>(null);

    // ─── Department-grouped layers state (left side) ─────────────────────────
    const [leftDepartments, setLeftDepartments] = useState<{ value: string; label: string }[]>([]);
    const [leftDeptFilter, setLeftDeptFilter] = useState<string>('');
    const [leftDeptLabel, setLeftDeptLabel] = useState<string>('');
    const [leftSubCatFilter, setLeftSubCatFilter] = useState<string>('');
    const [leftSubCategories, setLeftSubCategories] = useState<{ value: string; label: string }[]>([]);
    const [leftExpandedDepts, setLeftExpandedDepts] = useState<string[]>([]);
    const [leftDeptSearchText, setLeftDeptSearchText] = useState<string>('');
    const [leftDeptSuggestions, setLeftDeptSuggestions] = useState<{ value: string; label: string }[]>([]);
    const [leftShowDeptList, setLeftShowDeptList] = useState<boolean>(false);
    const [leftSubCatSearchText, setLeftSubCatSearchText] = useState<string>('');
    const [leftShowSubCatList, setLeftShowSubCatList] = useState<boolean>(false);

    // ─── Department-grouped layers state (right side) ────────────────────────
    const [rightDepartments, setRightDepartments] = useState<{ value: string; label: string }[]>([]);
    const [rightDeptFilter, setRightDeptFilter] = useState<string>('');
    const [rightDeptLabel, setRightDeptLabel] = useState<string>('');
    const [rightSubCatFilter, setRightSubCatFilter] = useState<string>('');
    const [rightSubCategories, setRightSubCategories] = useState<{ value: string; label: string }[]>([]);
    const [rightExpandedDepts, setRightExpandedDepts] = useState<string[]>([]);
    const [rightDeptSearchText, setRightDeptSearchText] = useState<string>('');
    const [rightDeptSuggestions, setRightDeptSuggestions] = useState<{ value: string; label: string }[]>([]);
    const [rightShowDeptList, setRightShowDeptList] = useState<boolean>(false);
    const [rightSubCatSearchText, setRightSubCatSearchText] = useState<string>('');
    const [rightShowSubCatList, setRightShowSubCatList] = useState<boolean>(false);

    mapRef.current = map;

    // ─── Fetch departments when mines change ─────────────────────────────────
    useEffect(() => {
        const mineId = selectedLeftMine?.value;
        if (!mineId) { setLeftDepartments([]); return; }
        setLeftDeptFilter(''); setLeftDeptLabel(''); setLeftSubCatFilter('');
        setLeftSubCategories([]); setLeftExpandedDepts([]);
        api?.get(url.DEPARTMENTS(mineId), {}, false)
            .then((resp: any) => {
                if (resp?.status?.toLowerCase() === 'success' && resp?.data) {
                    setLeftDepartments(resp.data.map((d: any) => ({ label: d.department, value: d.departmentId })));
                }
            })
            .catch(() => {});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedLeftMine?.value]);

    useEffect(() => {
        const mineId = selectedRightMine?.value;
        if (!mineId) { setRightDepartments([]); return; }
        setRightDeptFilter(''); setRightDeptLabel(''); setRightSubCatFilter('');
        setRightSubCategories([]); setRightExpandedDepts([]);
        api?.get(url.DEPARTMENTS(mineId), {}, false)
            .then((resp: any) => {
                if (resp?.status?.toLowerCase() === 'success' && resp?.data) {
                    setRightDepartments(resp.data.map((d: any) => ({ label: d.department, value: d.departmentId })));
                }
            })
            .catch(() => {});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedRightMine?.value]);

    // ─── Subcategory fetch ───────────────────────────────────────────────────
    const fetchSubCategories = useCallback((departmentId: string, side: 'left' | 'right') => {
        const setter = side === 'left' ? setLeftSubCategories : setRightSubCategories;
        if (!departmentId) { setter([]); return; }
        const mineId = side === 'left' ? selectedLeftMine?.value : selectedRightMine?.value;
        if (!mineId) return;
        api?.get(url.MINE_SUBCATEGORIES(mineId, departmentId), {}, false)
            .then((resp: any) => {
                if (resp?.status?.toLowerCase() === 'success' && resp?.data) {
                    setter((resp.data.subCategories || []).map((s: any) => ({ label: s.name, value: s.subCategoryId })));
                }
            })
            .catch(() => {});
    }, [api, selectedLeftMine?.value, selectedRightMine?.value]);

    // ─── Dept search handlers ────────────────────────────────────────────────
    const handleDeptSearch = (value: string, side: 'left' | 'right') => {
        const depts = side === 'left' ? leftDepartments : rightDepartments;
        const setSuggestions = side === 'left' ? setLeftDeptSuggestions : setRightDeptSuggestions;
        const setSearchText = side === 'left' ? setLeftDeptSearchText : setRightDeptSearchText;
        setSearchText(value);
        if (!value.trim()) { setSuggestions(depts.slice(0, 5)); return; }
        setSuggestions(depts.filter(d => d.label.toLowerCase().includes(value.toLowerCase())).slice(0, 5));
    };

    const handleDeptSelect = (opt: { value: string; label: string } | null, side: 'left' | 'right') => {
        if (side === 'left') {
            setLeftDeptFilter(opt?.value || ''); setLeftDeptLabel(opt?.label || '');
            setLeftDeptSearchText(''); setLeftShowDeptList(false);
            setLeftSubCatFilter(''); setLeftSubCatSearchText(''); setLeftSubCategories([]);
        } else {
            setRightDeptFilter(opt?.value || ''); setRightDeptLabel(opt?.label || '');
            setRightDeptSearchText(''); setRightShowDeptList(false);
            setRightSubCatFilter(''); setRightSubCatSearchText(''); setRightSubCategories([]);
        }
        if (opt?.value) fetchSubCategories(opt.value, side);
    };

    // ─── Filtered layers & grouping ──────────────────────────────────────────
    const filteredLeftLayers = useMemo(() => {
        return (source1 || []).filter((s: any) => {
            if (leftDeptFilter && (s.departmentId || '') !== leftDeptFilter) return false;
            if (leftSubCatFilter && (s.subCategoryId || '') !== leftSubCatFilter) return false;
            return true;
        }).slice(0, 100);
    }, [source1, leftDeptFilter, leftSubCatFilter]);

    const filteredRightLayers = useMemo(() => {
        return (source2 || []).filter((s: any) => {
            if (rightDeptFilter && (s.departmentId || '') !== rightDeptFilter) return false;
            if (rightSubCatFilter && (s.subCategoryId || '') !== rightSubCatFilter) return false;
            return true;
        }).slice(0, 100);
    }, [source2, rightDeptFilter, rightSubCatFilter]);

    const getDeptGroups = (layers: any[]): { deptId: string; deptName: string; layers: any[] }[] => {
        const grouped: Record<string, { deptId: string; deptName: string; layers: any[] }> = {};
        layers.forEach((src: any) => {
            const id = src.departmentId || 'unknown';
            if (!grouped[id]) grouped[id] = { deptId: id, deptName: src.departmentName || id, layers: [] };
            grouped[id].layers.push(src);
        });
        return Object.values(grouped);
    };

    const toggleDept = (deptId: string, side: 'left' | 'right') => {
        const setter = side === 'left' ? setLeftExpandedDepts : setRightExpandedDepts;
        setter(prev => prev.includes(deptId) ? prev.filter(id => id !== deptId) : [...prev, deptId]);
    };

    const isDeptAllSelected = (layers: any[]) => layers.length > 0 && layers.every((s: any) => s?.visibility);
    const isDeptSomeSelected = (layers: any[]) => !isDeptAllSelected(layers) && layers.some((s: any) => s?.visibility);

    const handleDeptSelectAll = (layers: any[], checked: boolean, isLeft: boolean) => {
        const refSet = new Set(layers.map((l: any) => l.sourceRef));
        const nameSet = new Set(layers.map((l: any) => l.sourceName));

        // Batch update state in one call
        const setter = isLeft ? setSource1 : setSource2;
        const sourceData = isLeft ? source1 : source2;
        const updated: any = sourceData?.map((item: any) =>
            refSet.has(item.sourceRef) ? { ...item, visibility: checked } : item
        );
        setter(updated);

        // Update map layer visibility (only the panel-specific layers)
        if (map) {
            const panelLayers: any[] = (isLeft ? layerState1 : layerState2) || [];
            panelLayers.forEach((layer: any) => {
                if (layer instanceof VectorLayer) {
                    const features = layer.getSource()?.getFeatures() || [];
                    const hasMatch = features.some((f: any) => nameSet.has(f.get('name')));
                    if (hasMatch) layer.setVisible(checked);
                } else if (layer instanceof ImageLayer) {
                    const source = layer.getSource();
                    if (source instanceof ImageWMS) {
                        const sourceName = source.getParams().LAYERS;
                        if (nameSet.has(sourceName)) layer.setVisible(checked);
                    }
                }
            });
        }
    };

    useEffect(() => {
        const compareMaps = async () => {
            // Detect which side changed before any async work to avoid race conditions
            const rightChanged = prevRightMineRef.current !== null && prevRightMineRef.current?.value !== selectedRightMine?.value;
            const zoomTarget = rightChanged ? selectedRightMine : selectedLeftMine;
            prevRightMineRef.current = selectedRightMine;

            setLoading(true);

            if (map) {
                deleteElevation('.ol-viewport');
            }

            const GEOSERVER_URL = process.env.REACT_APP_GEOSERVER_URL || '';
            const extentMap = await fetchAndParseCapabilities(GEOSERVER_URL);

            const mine1Data = await getSources(selectedLeftMine?.value);
            const sources1Layer = Createlayers(mine1Data, extentMap);
            setSource1(mine1Data);

            const feature1Data = await getFeatures(selectedLeftMine?.value);
            const drawn1Layers = CreateDrawlayers(feature1Data || []);
            setFeature1(feature1Data);

            let mine2Data = await getSources(selectedRightMine?.value);
            const sources2Layer = Createlayers(mine2Data, extentMap);
            setSource2(mine2Data);

            const feature2Data = await getFeatures(selectedRightMine?.value);
            const drawn2Layers = CreateDrawlayers(feature2Data || []);
            setFeature2(feature2Data);

            const layers1: any = [...sources1Layer[0], ...drawn1Layers];
            const layers2: any = [...sources2Layer[0], ...drawn2Layers];

            const osm = new TileLayer({
                source: new OSM()
            });

            const map1: any = new Map({
                target: mapElement.current,
                layers: [osm, ...layers1, ...layers2],
                view: new View({
                    center: fromLonLat([79.5, 18.0]),
                    zoom: 8
                }),
                controls: defaultControls().extend([
                    new ScaleLine({
                        units: 'metric',
                        bar: true,
                        steps: 4,
                        text: true,
                        minWidth: 140
                    }),
                    new FullScreen()
                ])
            });

            // Zoom to the changed mine's coordinates; fallback to default India view
            const targetMineData = zoomTarget?.data ?? {};
            const { minLatLong, maxLatLong } = targetMineData;
            let fittedToMine = false;

            if (minLatLong && maxLatLong) {
                const [a1, b1] = minLatLong.split(',').map(Number);
                const [a2, b2] = maxLatLong.split(',').map(Number);
                // Longitude always has larger absolute value than latitude for the same location.
                // Compare max absolute values across both points to detect which pair is lon.
                const maxAbsA = Math.max(Math.abs(a1), Math.abs(a2));
                const maxAbsB = Math.max(Math.abs(b1), Math.abs(b2));
                const [lat1, lon1] = maxAbsA > maxAbsB ? [b1, a1] : [a1, b1];
                const [lat2, lon2] = maxAbsA > maxAbsB ? [b2, a2] : [a2, b2];
                const minLat = Math.min(lat1, lat2);
                const maxLat = Math.max(lat1, lat2);
                const minLon = Math.min(lon1, lon2);
                const maxLon = Math.max(lon1, lon2);
                const validCoords = ![minLat, minLon, maxLat, maxLon].some(isNaN) && maxLon > minLon && maxLat > minLat;
                if (validCoords) {
                    try {
                        const extent3857 = transformExtent([minLon, minLat, maxLon, maxLat], 'EPSG:4326', 'EPSG:3857');
                        map1.getView().fit(extent3857, { padding: [60, 60, 60, 60], maxZoom: 16 });
                        fittedToMine = true;
                    } catch {
                        // invalid extent — fall through to default India view
                    }
                }
            }

            // Fallback: zoom to default India map view
            if (!fittedToMine) {
                const indiaExtent = transformExtent([68.7, 6.5, 97.25, 35.5], 'EPSG:4326', 'EPSG:3857');
                map1.getView().fit(indiaExtent, { padding: [60, 60, 60, 60], maxZoom: 16 });
                toast.warn('Mine coordinates are not configured properly. Showing default India view.');
            }

            setLayerState1(layers1);
            setLayerState2(layers2);

            let ctrl: any = new Swipe();

            layers1.map((layer: any) => {
                ctrl.addLayer(layer, false);
            });
            layers2.map((layer: any) => {
                ctrl.addLayer(layer, true);
            });

            map1.addControl(ctrl);

            setMap(map1);
            setLoading(false);
            setControl(ctrl);
        };
        compareMaps();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedLeftMine, selectedRightMine]);

    const deleteElevation = (data: string) => {
        const boxes = document.querySelectorAll(data);
        if (boxes.length > 0) {
            boxes.forEach((box) => {
                box.remove();
            });
        }
    };

    const getSources = (mineRef?: any) => {
        const payLoad = {
            params: { roleCode: role, search: JSON.stringify({ mineId: mineRef }) }
        };
        setLoading(true);
        return api
            .get(url?.GET_SOURCES, payLoad, false, false)
            .then((resp: any) => {
                if (resp?.status?.toLowerCase() === 'success' && resp?.data) {
                    const sorted = resp?.data?.data?.sort((a: any, b: any) => a.priority - b.priority);
                    return sorted;
                }
            })
            .catch((error: any) => {
                // reject(error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const getFeatures = (mineRef?: any) => {
        const payLoad = {
            params: { search: JSON.stringify({ mineId: mineRef }) }
        };
        setLoading(true);
        return api
            .get(url.GET_FEATURE, payLoad, false, true)
            .then((resp: any) => {
                if (resp?.status?.toLowerCase() === 'success' && resp?.data) {
                    const updated = resp?.data?.data?.map((ele: any) => ({ ...ele, visibility: true, vector: true }));
                    return updated;
                }
            })
            .catch((error: any) => {
                // reject(error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const toggleLayersDropdown = () => {
        setIsLayersDropDown(!isLayersDropdown);
    };

    const toggleLayersDropdown2 = () => {
        setIsLayersDropDown2(!isLayersDropdown2);
    };

    const toggleLayersDropdown3 = () => {
        setIsLayersDropDown3(!isLayersDropdown3);
    };

    const toggleLayersDropdown4 = () => {
        setIsLayersDropDown4(!isLayersDropdown4);
    };

    // ─── Drawn-layer grouping (by layerName, matching BottomPanal) ────────────
    const getGroupedFeatures = (features: any[]) => {
        return (features || [])
            .filter((f: any) => f?.layerName && !f?.isAdminBuffer)
            .reduce((acc: Record<string, any[]>, f: any) => {
                if (!acc[f.layerName]) acc[f.layerName] = [];
                acc[f.layerName].push(f);
                return acc;
            }, {} as Record<string, any[]>);
    };

    const changeAllFeatureVisibility = (isLeft: boolean) => {
        const currentSelectAll = isLeft ? selectAll : selectAll2;
        const newVisible = !currentSelectAll;
        const featuresList = isLeft ? feature1 : feature2;
        const setFeatures = isLeft ? setFeature1 : setFeature2;
        const setSelectAllFn = isLeft ? setSelectAll : setSelectAll2;

        const updated = featuresList?.map((f: any) => ({ ...f, visibility: newVisible }));
        setFeatures(updated);
        setSelectAllFn(newVisible);

        if (map) {
            const panelLayers: any[] = (isLeft ? layerState1 : layerState2) || [];
            panelLayers.forEach((layer: any) => {
                if (layer instanceof VectorLayer) {
                    const layerFeatures = layer.getSource()?.getFeatures() || [];
                    const featureName = layerFeatures.length > 0 ? layerFeatures[0]?.get('name') : null;
                    if (featureName && featuresList?.some((f: any) => f.featureName === featureName)) {
                        layer.setVisible(newVisible);
                    }
                }
            });
        }
    };

    const changeLayerGroupVisibility = (layerName: string, checked: boolean, isLeft: boolean) => {
        const featuresList = isLeft ? feature1 : feature2;
        const setFeatures = isLeft ? setFeature1 : setFeature2;

        const updated = featuresList?.map((f: any) => {
            if (f?.layerName === layerName) return { ...f, visibility: checked };
            return f;
        });
        setFeatures(updated);

        // Update selectAll state
        const unchecked = updated?.find((f: any) => !f?.visibility);
        isLeft ? setSelectAll(!unchecked) : setSelectAll2(!unchecked);

        if (map) {
            const panelLayers: any[] = (isLeft ? layerState1 : layerState2) || [];
            panelLayers.forEach((layer: any) => {
                if (layer instanceof VectorLayer) {
                    const layerFeatures = layer.getSource()?.getFeatures() || [];
                    const featureName = layerFeatures.length > 0 ? layerFeatures[0]?.get('name') : null;
                    if (featureName && featuresList?.some((f: any) => f.featureName === featureName && f.layerName === layerName)) {
                        layer.setVisible(checked);
                    }
                }
            });
        }
    };

    const handleVisibility = (e: any, ele: any, isLeft: boolean, type: string) => {
        const visible = e.target.checked;
        if (type === 'source') {
            if (isLeft) {
                const data: any = source1?.map((item: any) => {
                    if (item?.sourceRef === ele?.sourceRef) {
                        return { ...item, visibility: visible };
                    }
                    return item;
                });
                setSource1(data);
            } else {
                const data: any = source2?.map((item: any) => {
                    if (item?.sourceRef === ele?.sourceRef) {
                        return { ...item, visibility: visible };
                    }
                    return item;
                });
                setSource2(data);
            }
        } else {
            if (isLeft) {
                const data: any = feature1?.map((item: any) => {
                    if (item?.featureRef === ele?.featureRef) {
                        return { ...item, visibility: visible };
                    }
                    return item;
                });
                setFeature1(data);
            } else {
                const data: any = feature2?.map((item: any) => {
                    if (item?.featureRef === ele?.featureRef) {
                        return { ...item, visibility: visible };
                    }
                    return item;
                });
                setFeature2(data);
            }
        }
        if (map) {
            const targetFeatureName = type === 'source' ? ele.sourceName : ele.featureName;

            const layers: any[] = (isLeft ? layerState1 : layerState2) || [];

            layers.forEach((layer: any) => {
                if (layer instanceof VectorLayer) {
                    const features = layer.getSource()?.getFeatures() || [];
                    const hasMatch = features.some((f: any) => f.get('name') === targetFeatureName);
                    if (hasMatch) {
                        layer.setVisible(visible);
                    }
                } else if (layer instanceof ImageLayer) {
                    const source = layer.getSource();
                    if (source instanceof ImageWMS) {
                        const sourceName = source.getParams().LAYERS;
                        if (sourceName === targetFeatureName) {
                            layer.setVisible(visible);
                        }
                    }
                }
            });
        }
    };
    
    return (
        <React.Fragment>
            <div
                ref={mapElement}
                className="map-container"
                style={{
                    width: '100%',
                    height: '100vh'
                }}
            ></div>
            <div className="left-select">
                <Select className="w-100" options={mines} value={selectedLeftMine} onChange={(val: any) => setSelectedLeftMine(val)} />
                {/* <Input
                    value={
                        selectedLeftMine?.data?.miningDate
                            ? new Date(selectedLeftMine?.data?.miningDate)?.toISOString()?.split('T')[0]
                            : undefined
                    }
                    type="date"
                /> */}
                <Input
                    value={selectedLeftMine?.data?.miningDate ? getDateOnly(selectedLeftMine?.data?.miningDate) : undefined}
                    type="text"
                />
            </div>
            <div className="right-select">
                <Select className="w-100" options={mines} value={selectedRightMine} onChange={(val: any) => setSelectedRightMine(val)} />
                <Input
                    value={selectedRightMine?.data?.miningDate ? getDateOnly(selectedRightMine?.data?.miningDate) : undefined}
                    type="text"
                />
            </div>

            <div className="bottom-panal">
                <Dropdown className="card-header-dropdown p-0 m-0" isOpen={isLayersDropdown} toggle={toggleLayersDropdown} direction="end">
                    <DropdownToggle tag="a" className="text-reset dropdown-btn" role="button">
                        <div className="bottom-layers">
                            <img src={layerimg} alt="layerimg" />
                            <div className="text-center">Drawn Layers</div>
                        </div>
                    </DropdownToggle>
                    <DropdownMenu className="tools-menu-top1 p-0">
                        <Card className="p-0 m-0 br-0 brd-none">
                            <CardHeader className="d-flex align-items-center justify-content-between bg-success br-0 m-0 ps-2 ms-0">
                                <div className="text-light fs-6">
                                    <span className="me-3">
                                        <Input
                                            className="cursor-pointer"
                                            type="checkbox"
                                            checked={selectAll}
                                            onChange={() => changeAllFeatureVisibility(true)}
                                        />
                                    </span>
                                    Layers
                                </div>
                                <i className="bx bx-x fs-4 pointer text-light" onClick={toggleLayersDropdown}></i>
                            </CardHeader>
                            <CardBody className="p-2 h-25vh overflow-y-scroll overflow-x-hidden">
                                {Object.keys(getGroupedFeatures(feature1)).length > 0 ? (
                                    <Row>
                                        {Object.entries(getGroupedFeatures(feature1)).map(([layerName, features]: any, key) => {
                                            const isChecked = features?.every((f: any) => f?.visibility);
                                            return (
                                                <Col key={key} sm={12}>
                                                    <div className="mb-2 layer-dropdown pe-3">
                                                        <div className="d-flex">
                                                            <span className="me-3">
                                                                <Input
                                                                    className="cursor-pointer"
                                                                    type="checkbox"
                                                                    checked={isChecked}
                                                                    onChange={(e: any) => changeLayerGroupVisibility(layerName, e.target.checked, true)}
                                                                />
                                                            </span>
                                                            <span
                                                                className={`truncate-96 has-tooltip-top ${isChecked ? 'text-decoration-underline' : ''}`}
                                                                title={layerName}
                                                                onClick={() => isChecked && map && fitMapToLayerDetails(map, { layerName, features })}
                                                            >{layerName}</span>
                                                        </div>
                                                    </div>
                                                </Col>
                                            );
                                        })}
                                    </Row>
                                ) : (
                                    <div className="text-center">No Layers available</div>
                                )}
                            </CardBody>
                        </Card>
                    </DropdownMenu>
                </Dropdown>
            </div>

            <div className="bottom-panal_1">
                <Dropdown
                    className="card-header-dropdown p-0 m-0"
                    isOpen={isLayersDropdown2}
                    toggle={toggleLayersDropdown2}
                    direction="end"
                >
                    <DropdownToggle tag="a" className="text-reset dropdown-btn" role="button">
                        <div className="bottom-layers">
                            <img src={layerimg} alt="layerimg" />
                            <div className="text-center">Drawn Layers</div>
                        </div>
                    </DropdownToggle>
                    <DropdownMenu className="tools-menu-top p-0">
                        <Card className="p-0 m-0 br-0 brd-none">
                            <CardHeader className="d-flex align-items-center justify-content-between bg-success br-0 m-0 ps-2 ms-0">
                                <div className="text-light fs-6">
                                    <span className="me-3">
                                        <Input
                                            className="cursor-pointer"
                                            type="checkbox"
                                            checked={selectAll2}
                                            onChange={() => changeAllFeatureVisibility(false)}
                                        />
                                    </span>
                                    Layers
                                </div>
                                <i className="bx bx-x fs-4 pointer text-light" onClick={toggleLayersDropdown2}></i>
                            </CardHeader>
                            <CardBody className="p-2 h-25vh overflow-y-scroll overflow-x-hidden">
                                {Object.keys(getGroupedFeatures(feature2)).length > 0 ? (
                                    <Row>
                                        {Object.entries(getGroupedFeatures(feature2)).map(([layerName, features]: any, key) => {
                                            const isChecked = features?.every((f: any) => f?.visibility);
                                            return (
                                                <Col key={key} sm={12}>
                                                    <div className="mb-2 layer-dropdown pe-3">
                                                        <div className="d-flex">
                                                            <span className="me-3">
                                                                <Input
                                                                    className="cursor-pointer"
                                                                    type="checkbox"
                                                                    checked={isChecked}
                                                                    onChange={(e: any) => changeLayerGroupVisibility(layerName, e.target.checked, false)}
                                                                />
                                                            </span>
                                                            <span
                                                                className={`truncate-96 has-tooltip-top ${isChecked ? 'text-decoration-underline' : ''}`}
                                                                title={layerName}
                                                                onClick={() => isChecked && map && fitMapToLayerDetails(map, { layerName, features })}
                                                            >{layerName}</span>
                                                        </div>
                                                    </div>
                                                </Col>
                                            );
                                        })}
                                    </Row>
                                ) : (
                                    <div className="text-center">No Layers available</div>
                                )}
                            </CardBody>
                        </Card>
                    </DropdownMenu>
                </Dropdown>
            </div>

            {/* Right source layers (department-grouped) */}
            <div className="top-panal-right">
                <Dropdown
                    className="card-header-dropdown p-0 m-0"
                    isOpen={isLayersDropdown3}
                    toggle={() => { setRightShowDeptList(false); setRightShowSubCatList(false); toggleLayersDropdown3(); }}
                    direction="end"
                >
                    <DropdownToggle tag="a" className="text-reset dropdown-btn" role="button">
                        <div className="bottom-layers">
                            <img src={layerimg} alt="layerimg" />
                        </div>
                    </DropdownToggle>
                    <DropdownMenu className="tools-menu-top layers-popup p-0">
                        <Card className="p-0 m-0 br-0 brd-none w-100">
                            <CardHeader className="d-flex align-items-center justify-content-between bg-primary br-0 m-0 ps-2 ms-0">
                                <div className="text-light fs-6">Layers</div>
                                <i className="bx bx-x fs-4 pointer text-light" onClick={toggleLayersDropdown3}></i>
                            </CardHeader>
                            {/* Department & SubCategory filter dropdowns */}
                            <div className="d-flex gap-2 px-2 pt-2 pb-1 w-100">
                                <div className="position-relative flex-grow-1">
                                    {rightShowDeptList && <div className="layer-search-overlay" onClick={() => setRightShowDeptList(false)} />}
                                    <div
                                        className="form-select form-select-sm pointer"
                                        onClick={() => {
                                            const opening = !rightShowDeptList;
                                            setRightShowDeptList(opening);
                                            setRightShowSubCatList(false);
                                            if (opening) { setRightDeptSearchText(''); setRightDeptSuggestions(rightDepartments.slice(0, 5)); }
                                        }}
                                    >
                                        {rightDeptLabel || 'All Departments'}
                                    </div>
                                    {rightShowDeptList && (
                                        <div className="layer-search-dropdown-menu">
                                            <input type="text" className="form-control form-control-sm mb-1" placeholder="Search department..."
                                                value={rightDeptSearchText} autoFocus onChange={e => handleDeptSearch(e.target.value, 'right')} />
                                            <div className="layer-search-options">
                                                <div className={`layer-search-option ${!rightDeptFilter ? 'active' : ''}`}
                                                    onMouseDown={() => handleDeptSelect(null, 'right')}>All Departments</div>
                                                {rightDeptSuggestions.map(opt => (
                                                    <div key={opt.value} className={`layer-search-option ${rightDeptFilter === opt.value ? 'active' : ''}`}
                                                        onMouseDown={() => handleDeptSelect(opt, 'right')}>{opt.label}</div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="position-relative flex-grow-1">
                                    {rightShowSubCatList && <div className="layer-search-overlay" onClick={() => setRightShowSubCatList(false)} />}
                                    <div className={`form-select form-select-sm ${!rightDeptFilter ? 'opacity-50' : 'pointer'}`}
                                        onClick={() => {
                                            if (!rightDeptFilter) return;
                                            const opening = !rightShowSubCatList;
                                            setRightShowSubCatList(opening); setRightShowDeptList(false);
                                            if (opening) setRightSubCatSearchText('');
                                        }}>
                                        {rightSubCatFilter ? rightSubCategories.find(o => o.value === rightSubCatFilter)?.label || 'All Sub Categories' : 'All Sub Categories'}
                                    </div>
                                    {rightShowSubCatList && rightDeptFilter && (
                                        <div className="layer-search-dropdown-menu">
                                            <input type="text" className="form-control form-control-sm mb-1" placeholder="Search sub-category..."
                                                value={rightSubCatSearchText} autoFocus onChange={e => setRightSubCatSearchText(e.target.value)} />
                                            <div className="layer-search-options">
                                                <div className={`layer-search-option ${!rightSubCatFilter ? 'active' : ''}`}
                                                    onMouseDown={() => { setRightSubCatFilter(''); setRightSubCatSearchText(''); setRightShowSubCatList(false); }}>All Sub Categories</div>
                                                {rightSubCategories
                                                    .filter(o => !rightSubCatSearchText || o.label.toLowerCase().includes(rightSubCatSearchText.toLowerCase()))
                                                    .slice(0, 5).map(opt => (
                                                        <div key={opt.value} className={`layer-search-option ${rightSubCatFilter === opt.value ? 'active' : ''}`}
                                                            onMouseDown={() => { setRightSubCatFilter(opt.value); setRightSubCatSearchText(''); setRightShowSubCatList(false); }}>{opt.label}</div>
                                                    ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <CardBody className="p-0">
                                <div className="layersDropDown px-2 pt-1 max-height-100">
                                    {filteredRightLayers.length > 0 ? (
                                        getDeptGroups(filteredRightLayers).map(({ deptId, deptName, layers }) => {
                                            const isExpanded = rightExpandedDepts.includes(deptId);
                                            return (
                                                <div key={deptId} className="mb-1">
                                                    <div className="dept-row d-flex align-items-center py-1 px-2 pointer" onClick={() => toggleDept(deptId, 'right')}>
                                                        <span className={`dept-toggle-btn me-2 ${isExpanded ? 'expanded' : ''}`}>{isExpanded ? '-' : '+'}</span>
                                                        <span className="fs-13 fw-semibold">{deptName}</span>
                                                    </div>
                                                    {isExpanded && (
                                                        <div className="ps-2 pt-1">
                                                            <div className="layer-dropdown-row ps-3 pe-2">
                                                                <div className="flex-shrink-0">
                                                                    <Input type="checkbox" checked={isDeptAllSelected(layers)}
                                                                        innerRef={(el: any) => { if (el) el.indeterminate = isDeptSomeSelected(layers); }}
                                                                        onChange={(e: any) => handleDeptSelectAll(layers, e.target.checked, false)} />
                                                                </div>
                                                                <div className="fs-12 text-muted layer-name-cell ps-3">Select All</div>
                                                            </div>
                                                            <div className="ms-3 mb-2" style={{ borderBottom: "1px dashed #dee2e6" }}></div>
                                                            {layers.map((source: any) => (
                                                                <div className="mb-2 layer-dropdown-row ps-3 pe-2" key={source.sourceRef || source.sourceName}>
                                                                    <div className="flex-shrink-0">
                                                                        <Input type="checkbox" checked={source?.visibility}
                                                                            onChange={(e: any) => handleVisibility(e, source, false, 'source')} />
                                                                    </div>
                                                                    <div className="fs-13 layer-name-cell ps-3" title={source?.sourceDisplayName}>
                                                                        {source?.sourceDisplayName}{source?.area != null ? ' - ' + source.area : ''}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })
                                    ) : (
                                        <div className="text-center py-3">No Layers available</div>
                                    )}
                                </div>
                            </CardBody>
                        </Card>
                    </DropdownMenu>
                </Dropdown>
            </div>

            {/* Left source layers (department-grouped) */}
            <div className="top-panal-left">
                <Dropdown
                    className="card-header-dropdown p-0 m-0"
                    isOpen={isLayersDropdown4}
                    toggle={() => { setLeftShowDeptList(false); setLeftShowSubCatList(false); toggleLayersDropdown4(); }}
                    direction="end"
                >
                    <DropdownToggle tag="a" className="text-reset dropdown-btn" role="button">
                        <div className="bottom-layers">
                            <img src={layerimg} alt="layerimg" />
                        </div>
                    </DropdownToggle>
                    <DropdownMenu className="tools-menu-top layers-popup p-0">
                        <Card className="p-0 m-0 br-0 brd-none w-100">
                            <CardHeader className="d-flex align-items-center justify-content-between bg-primary br-0 m-0 ps-2 ms-0">
                                <div className="text-light fs-6">Layers</div>
                                <i className="bx bx-x fs-4 pointer text-light" onClick={toggleLayersDropdown4}></i>
                            </CardHeader>
                            {/* Department & SubCategory filter dropdowns */}
                            <div className="d-flex gap-2 px-2 pt-2 pb-1 w-100">
                                <div className="position-relative flex-grow-1">
                                    {leftShowDeptList && <div className="layer-search-overlay" onClick={() => setLeftShowDeptList(false)} />}
                                    <div
                                        className="form-select form-select-sm pointer"
                                        onClick={() => {
                                            const opening = !leftShowDeptList;
                                            setLeftShowDeptList(opening);
                                            setLeftShowSubCatList(false);
                                            if (opening) { setLeftDeptSearchText(''); setLeftDeptSuggestions(leftDepartments.slice(0, 5)); }
                                        }}
                                    >
                                        {leftDeptLabel || 'All Departments'}
                                    </div>
                                    {leftShowDeptList && (
                                        <div className="layer-search-dropdown-menu">
                                            <input type="text" className="form-control form-control-sm mb-1" placeholder="Search department..."
                                                value={leftDeptSearchText} autoFocus onChange={e => handleDeptSearch(e.target.value, 'left')} />
                                            <div className="layer-search-options">
                                                <div className={`layer-search-option ${!leftDeptFilter ? 'active' : ''}`}
                                                    onMouseDown={() => handleDeptSelect(null, 'left')}>All Departments</div>
                                                {leftDeptSuggestions.map(opt => (
                                                    <div key={opt.value} className={`layer-search-option ${leftDeptFilter === opt.value ? 'active' : ''}`}
                                                        onMouseDown={() => handleDeptSelect(opt, 'left')}>{opt.label}</div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="position-relative flex-grow-1">
                                    {leftShowSubCatList && <div className="layer-search-overlay" onClick={() => setLeftShowSubCatList(false)} />}
                                    <div className={`form-select form-select-sm ${!leftDeptFilter ? 'opacity-50' : 'pointer'}`}
                                        onClick={() => {
                                            if (!leftDeptFilter) return;
                                            const opening = !leftShowSubCatList;
                                            setLeftShowSubCatList(opening); setLeftShowDeptList(false);
                                            if (opening) setLeftSubCatSearchText('');
                                        }}>
                                        {leftSubCatFilter ? leftSubCategories.find(o => o.value === leftSubCatFilter)?.label || 'All Sub Categories' : 'All Sub Categories'}
                                    </div>
                                    {leftShowSubCatList && leftDeptFilter && (
                                        <div className="layer-search-dropdown-menu">
                                            <input type="text" className="form-control form-control-sm mb-1" placeholder="Search sub-category..."
                                                value={leftSubCatSearchText} autoFocus onChange={e => setLeftSubCatSearchText(e.target.value)} />
                                            <div className="layer-search-options">
                                                <div className={`layer-search-option ${!leftSubCatFilter ? 'active' : ''}`}
                                                    onMouseDown={() => { setLeftSubCatFilter(''); setLeftSubCatSearchText(''); setLeftShowSubCatList(false); }}>All Sub Categories</div>
                                                {leftSubCategories
                                                    .filter(o => !leftSubCatSearchText || o.label.toLowerCase().includes(leftSubCatSearchText.toLowerCase()))
                                                    .slice(0, 5).map(opt => (
                                                        <div key={opt.value} className={`layer-search-option ${leftSubCatFilter === opt.value ? 'active' : ''}`}
                                                            onMouseDown={() => { setLeftSubCatFilter(opt.value); setLeftSubCatSearchText(''); setLeftShowSubCatList(false); }}>{opt.label}</div>
                                                    ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <CardBody className="p-0">
                                <div className="layersDropDown px-2 pt-1 max-height-100">
                                    {filteredLeftLayers.length > 0 ? (
                                        getDeptGroups(filteredLeftLayers).map(({ deptId, deptName, layers }) => {
                                            const isExpanded = leftExpandedDepts.includes(deptId);
                                            return (
                                                <div key={deptId} className="mb-1">
                                                    <div className="dept-row d-flex align-items-center py-1 px-2 pointer" onClick={() => toggleDept(deptId, 'left')}>
                                                        <span className={`dept-toggle-btn me-2 ${isExpanded ? 'expanded' : ''}`}>{isExpanded ? '-' : '+'}</span>
                                                        <span className="fs-13 fw-semibold">{deptName}</span>
                                                    </div>
                                                    {isExpanded && (
                                                        <div className="ps-2 pt-1">
                                                            <div className="layer-dropdown-row ps-3 pe-2">
                                                                <div className="flex-shrink-0">
                                                                    <Input type="checkbox" checked={isDeptAllSelected(layers)}
                                                                        innerRef={(el: any) => { if (el) el.indeterminate = isDeptSomeSelected(layers); }}
                                                                        onChange={(e: any) => handleDeptSelectAll(layers, e.target.checked, true)} />
                                                                </div>
                                                                <div className="fs-12 text-muted layer-name-cell ps-3">Select All</div>
                                                            </div>
                                                            <div className="ms-3 mb-2" style={{ borderBottom: "1px dashed #dee2e6" }}></div>
                                                            {layers.map((source: any) => (
                                                                <div className="mb-2 layer-dropdown-row ps-3 pe-2" key={source.sourceRef || source.sourceName}>
                                                                    <div className="flex-shrink-0">
                                                                        <Input type="checkbox" checked={source?.visibility}
                                                                            onChange={(e: any) => handleVisibility(e, source, true, 'source')} />
                                                                    </div>
                                                                    <div className="fs-13 layer-name-cell ps-3" title={source?.sourceDisplayName}>
                                                                        {source?.sourceDisplayName}{source?.area != null ? ' - ' + source.area : ''}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })
                                    ) : (
                                        <div className="text-center py-3">No Layers available</div>
                                    )}
                                </div>
                            </CardBody>
                        </Card>
                    </DropdownMenu>
                </Dropdown>
            </div>

            <div className="d-flex justify-content-center align-items-center ms-5">
                <img
                    src={homeImg}
                    alt="home"
                    className="cursor-pointer home"
                    id="home"
                    onClick={() => {
                        const homeRoute =
                            role === 'ADMIN'
                                ? '/admin-map-view'
                                : role === 'NODAL_OFFICER'
                                    ? '/nodal-officer-map-view'
                                    : '/clientMap';
                        props?.router?.navigate(homeRoute, { state: { header: 'hide' } });
                    }}
                />
            </div>
        </React.Fragment>
    );
};

export default withRouter(ComparisionTool);
